import React from 'react';
import { Skeleton } from 'antd';
import { useTranslations } from 'next-intl';

import { UserActivityCard, useUserProfileResult } from 'modules/cabinet';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

const RightSideRecentActivity = () => {
  const t = useTranslations('profile');
  const { data: resultData, isLoading: resultLoading } = useUserProfileResult();

  return (
    <div>
      <div className="my-4 rounded-xl bg-white p-4 text-[0.938rem]">{t('right_side.songgi_faollik')}</div>

      <Visible
        if={resultLoading}
        else={
          <Visible
            if={isEmptyArr(resultData)}
            else={resultData?.map(result => (
              <UserActivityCard
                key={result.id}
                type={result.type}
                id={result.id}
                createdAt={result.created_at}
                ball={result.ball}
              />
            ))}
          >
            <EmptyData title={t('no_data')} />
          </Visible>
        }
      >
        <div className="mb-4 rounded-xl bg-white p-4">
          <div className="flex items-center justify-between">
            <Skeleton.Button active size="small" shape="square" style={{ width: 80 }} />
            <Skeleton.Input active size="small" className="!w-50" />
          </div>
          <div className="my-4 flex items-center justify-between">
            <Skeleton.Input active size="small" className="!w-40" />
            <Skeleton.Input active size="small" />
          </div>
          <div className="flex items-center justify-between">
            <Skeleton.Input active size="small" />
            <Skeleton.Input active size="small" className="!w-50" />
          </div>
          <div className="mt-3">
            <Skeleton.Button active block size="large" shape="square" />
          </div>
        </div>
      </Visible>
    </div>
  );
};

export default RightSideRecentActivity;
